export const API_URL = 'https://rethymno-admin.repository.gr'

export const API_KEY = '6AhQEcRa8maJf3NjgdBw'

export const Cors = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
  }